<template>
  <div style="height: 100%">
    <div
      class="uploading"
      v-if="!slideData && !$data.isConverting"
      style="padding: 15px"
    >
      <Upload
        type="select"
        :action="uploadServer"
        :on-success="handleUpload"
        :on-progress="uploadProgress"
        :data="uploadData()"
        :format="['pdf']"
        :max-size="300000"
      >
        <Button icon="ios-cloud-upload-outline">Upload</Button>
      </Upload>
    </div>
    <div
      class="uploading"
      v-if="$data.isReady && $data.isUploading"
      style="padding: 15px"
    >
      Uploading. Please wait...
      <Progress :percent="uploadPercent" :stroke-width="5" />
    </div>
    <div
      class="converting"
      v-if="$data.isReady && $data.isConverting"
      style="padding: 15px"
    >
      Converting slides. Please wait...
      <Spin size="large"></Spin>
    </div>
    <div
      class="slide-manager"
      v-if="
        $data.isReady &&
        !$data.isUploading &&
        !$data.isConverting &&
        this.slideData
      "
    >
      <div
        class="slide-container"
        :style="{
          'background-image':
            'url(' + slidePath + slideData.currentSlide + '.png)',
        }"
      >
        <!--<img :src="slidePath+currentSlide+'.png'"/>-->
      </div>
      <div class="control-bar">
        <Upload
          type="select"
          :action="uploadServer"
          :on-success="handleUpload"
          :on-progress="uploadProgress"
          :data="uploadData()"
          :format="['pdf']"
          :max-size="300000"
        >
          <Button icon="ios-cloud-upload-outline">Upload</Button>
        </Upload>

        <div class="controls">
          <Button
            type="text"
            icon="ios-arrow-dropleft-circle"
            @click="selectSlide(slideData.currentSlide - 1)"
            :disabled="slideData.currentSlide == 0"
          />
          <span
            >{{ slideData.currentSlide + 1 }} / {{ slideData.slideCount }}</span
          >
          <Button
            type="text"
            icon="ios-arrow-dropright-circle"
            @click="selectSlide(slideData.currentSlide + 1)"
            :disabled="slideData.currentSlide == slideData.slideCount - 1"
          />
        </div>
      </div>

      <div class="slide-selector" ref="slide-selector" :key="slideData.path">
        <div class="slide-list">
          <div
            class="slide-thumb"
            :class="{ selected: slideId == slideData.currentSlide }"
            v-for="(v, slideId) in slideData.slideCount"
            :key="slideId"
            v-on:click="selectSlide(slideId)"
          >
            <img :src="slidePath + slideId + '.png'" />
          </div>
        </div>
      </div>

      <!--
      <SlideSelector :key="slideData.path" :slideData="slideData"/>
      -->
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import $config from '@/config'
import axios from 'axios'
import SlideSelector from './SlideSelector.vue'

export default {
  components: {
    SlideSelector
  },
  data() {
    return {
      isReady: false,
      currentSlide: null,
      isUploading: false,
      uploadPercent: 0,
      isConverting: false
    }
  },
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('slides', {
      getSlideDataInStore: 'find'
    }),
    slideData() {
      let slideData = this.getSlideDataInStore({
        query: {
          webcastId: this.webcast._id,
          $sort: { createdAt: -1 }
        }
      }).data[0]
      console.log(slideData)
      if (slideData) {
        this.isConverting = slideData.isConverting
      }
      // console.log(slideData.isConverting);
      return slideData
    },
    slidePath() {
      return (
        'https://lcp.ams3.cdn.digitaloceanspaces.com/' +
        this.slideData.path +
        '/' +
        this.slideData.path +
        '-'
      )
    },
    uploadServer() {
      return $config.feathersServer + '/slideDeck/upload'
    }
  },
  methods: {
    ...mapActions('slides', {
      findSlide: 'find',
      updateSlide: 'patch'
    }),
    selectSlide(slideId) {
      this.updateSlide([this.slideData._id, { currentSlide: slideId }])
      this.$data.currentSlide = slideId

      /*
      setInterval(() => {
        console.log("pushing slide");
        console.log(this.$data.currentSlide);
        this.updateSlide([
          this.slideData._id,
          { currentSlide: this.$data.currentSlide }
        ]);
      }, 2000);
      */

      // change scroll of the slide list
      // this.$refs['slide-selector'].scrollLeft = 184*(this.currentSlide-2);
    },
    // Switch to uploading style
    uploadProgress(event, file, fileList) {
      console.log('beforeUpload')
      this.uploadPercent = event.percent
      this.isUploading = true
    },
    handleUpload(res, file) {
      this.isUploading = false
      console.log(res)
    },
    handleError(error, file, fileList) {
      this.isUploading = false
      console.log(error)
    },
    uploadData() {
      return { webcastId: this.webcast._id }
    }
  },
  created() {
    this.findSlide({ query: { webcastId: this.webcast._id } }).then(slide => {
      console.log(this.slideData)
      if (this.slideData) {
        this.$data.currentSlide = this.slideData.currentSlide
      } else {
        this.$data.currentSlide = 0
      }

      this.$data.isReady = true
    })
  }
}
</script>
<style lang="scss">
.slide-manager {
  height: 100%;
  background-color: #222;
  position: relative;
}
.slide-container {
  height: calc(100% - 204px);
  max-width: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  img {
    height: 100%;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
    max-width: 100%;
  }
}
.control-bar {
  padding: 8px;
  position: absolute;
  width: 100%;
  div {
    display: inline-block;
  }
  .controls {
    float: right;
    color: #ececec;
    .ivu-btn-text.ivu-btn-icon-only {
      padding: 0px;
      color: #fff;
      font-size: 20px;
      background-color: transparent;
      &:focus {
        box-shadow: none;
      }
      &:hover {
        background-color: transparent;
      }
    }
    .ivu-btn-text[disabled] {
      color: #999;
    }
    .ivu-icon {
      font-size: 36px;
      line-height: 36px;
    }
  }
}
.slide-selector {
  width: 100%;
  overflow-x: scroll;
  position: absolute;
  bottom: 2px;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 22px;
    background-color: #666;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    width: 4px;
    background-color: #000;
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
  .slide-list {
    display: inline-flex;
    width: auto;
    background-color: #444;
    .slide-thumb {
      width: 160px;
      margin: 10px 4px 0px;
      img {
        width: 100%;
        display: block;
      }
      &.selected {
        border: 4px solid #d33232;
      }
    }
  }
}
</style>
